export const getContextPanel = (state) => {
    const { form } = state;
    if (form) {
        return { ...form, isOpen: true };
    }
    return { isOpen: false };
};
